import React from "react";
const API = () => {
  return <div className="settings-tab">API</div>;
};
export default API;
